import { useState } from "react";

import AddressMap from "./AddressMap/AddressMap";

// icons
import { ReactComponent as BackIcon } from "../../../../../assets/svg/category-back.svg";
import { useTranslation } from "react-i18next";
import { Button, Drawer } from "antd";
import styles from "./AddEditAddress.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  ADDRESS_ACTION_TYPE,
  CLEAR,
} from "../../../../../store/actions/address_actions";

const AddEditAddress = ({ onSelectLocation, onSubmit }) => {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const { mapModalOpen, status } = useSelector((state) => state.Address);
  const dispatch = useDispatch();

  const hideModal = () => {
    dispatch(CLEAR());
  };

  return (
    <Drawer
      open={mapModalOpen}
      onClose={hideModal}
      destroyOnClose
      closable={false}
      placement="bottom"
      height="100%"
      styles={{
        body: {
          padding: "0px",
        },
      }}
    >
      <div className={styles.header}>
        <div className={styles.headerIconContainer} onClick={hideModal}>
          <BackIcon
            style={{
              rotate: i18n.dir() === "rtl" ? "180deg" : "0",
            }}
          />
        </div>
        <span className={styles.headerTitle}>
          {status === ADDRESS_ACTION_TYPE.EDIT
            ? t("cart.address_edit")
            : t("cart.address_new")}
        </span>
      </div>
      <div className="detail-container px-0">
        <div className="new-addr-box">
          <div className="form-row map-reletive address-map">
            <AddressMap onSubmit={onSubmit} />
          </div>
        </div>
        <div className="page-address-new-address-box">
          <Button
            type="primary"
            size="large"
            style={{
              width: "100%",
            }}
            loading={loading}
            onClick={() => {
              setLoading(true);
              onSelectLocation().finally(() => {
                setLoading(false);
              });
            }}
          >
            {status === ADDRESS_ACTION_TYPE.EDIT
              ? t("common.edit")
              : t("common.add")}
          </Button>
        </div>
      </div>
    </Drawer>
  );
};

export default AddEditAddress;
